// constants
import { VideoActionTypes } from "./constants";

export interface VideoActionType {
  type:
    | VideoActionTypes.API_RESPONSE_SUCCESS
    | VideoActionTypes.API_RESPONSE_ERROR
    | VideoActionTypes.UPDATE_VIDEO
    | VideoActionTypes.CREATE_VIDEO
    | VideoActionTypes.GET_VIDEO
    | VideoActionTypes.DELETE_VIDEO;
  payload: {} | string;
}

interface videoDetails {
  id: string;
  name: string;
  day: string;
  video: File | null;
  subCourseId: string;
}

// common success
export const videoApiResponseSuccess = (
  actionType: string,
  data: videoDetails | {}
): VideoActionType => ({
  type: VideoActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const videoApiResponseError = (
  actionType: string,
  error: string
): VideoActionType => ({
  type: VideoActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createVideo = (
  name: string,
  day: string,
  video: File | null,
  subCourseId: string
): VideoActionType => ({
  type: VideoActionTypes.CREATE_VIDEO,
  payload: { name, day, video, subCourseId },
});

export const getVideo = (): VideoActionType => ({
  type: VideoActionTypes.GET_VIDEO,
  payload: {},
});

export const deleteVideo = (id: string): VideoActionType => ({
  type: VideoActionTypes.DELETE_VIDEO,
  payload: { id },
});

export const updateVideo = (
  id: string,
  name: string,
  day: string,
  video: File | null,
  subCourseId: string
): VideoActionType => ({
  type: VideoActionTypes.UPDATE_VIDEO,
  payload: { id, name, day, video, subCourseId },
});